module.exports = __webpack_public_path__ + "static/media/Reservation-03.6bd0b61c.svg";